import { SxProps, Theme, Typography, TypographyProps } from '@mui/material';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectContentBackgroundColor } from '../../../store/selectors/derived';
import { getSecondaryTextColor } from '../../../util/ui';

interface IProps {
  children: React.ReactNode;
  variant?: TypographyProps['variant'];
  sx?: SxProps<Theme>;
}

export const Subtitle: React.FC<IProps> = ({ children, variant = 'body1', sx }) => {
  const bgColor = useSelector(selectContentBackgroundColor);

  const textColor = useMemo(() => {
    return getSecondaryTextColor(bgColor);
  }, [bgColor]);

  return (
    <Typography variant={variant} color={textColor} fontWeight="medium" sx={sx}>
      {children}
    </Typography>
  );
};
